import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  NextProject,
  useCreateMaterialReportMutation,
  useProject,
} from '../../actions/singleProjectAction';
import Icons from '../../assets/icons';
import textWeight from '../../utils/textWeight';

export default () => {
  const navigate = useNavigate();
  const projectID = useSelector((state) => state.app.projectID.projectID);
  const { data: ProjectData, isLoading } = useProject(projectID);
  const [quantityReport, setQuantityReport] = useState();
  const [materialReport, setMaterialReport] = useState();
  const { TextWeight } = textWeight();
  const [costingReport, setCostingReport] = useState();
  const [materialStatusReport, setMaterialStatusReport] = useState(
    ProjectData?.data?.materialReportStatus
  );
  const [openCostingReport, setOpenCostingReport] = useState(
    ProjectData?.data?.costingReportStatus === 'COMPLETED' ? true : false
  );
  const [costingStatusReport, setCostingStatusReport] = useState(
    ProjectData?.data?.costingReportStatus
  );
  const [isprojectMaterial, setIsprojectMaterial] = useState(
    ProjectData?.data?.materialReportStatus === 'COMPLETED' ? true : false
  );
  const [isprojectCost, setIsprojectCost] = useState(
    ProjectData?.data?.costingReportStatus === 'COMPLETED' ? true : false
  );
  useEffect(() => {
    if (ProjectData?.data) {
      if (ProjectData?.data?.quantityReport) {
        setQuantityReport(JSON.parse(ProjectData?.data?.quantityReport));
      }

      if (ProjectData?.data?.materialReportStatus === 'COMPLETED') {
        setMaterialReport(JSON.parse(ProjectData?.data?.materialReport));
      }

      if (ProjectData?.data?.costingReportStatus === 'COMPLETED') {
        setCostingReport(JSON.parse(ProjectData?.data?.costingReport));
      }

      setMaterialStatusReport(ProjectData?.data?.materialReportStatus);
      setCostingStatusReport(ProjectData?.data?.costingReportStatus);

      setIsprojectMaterial(
        ProjectData?.data?.materialReportStatus === 'COMPLETED' ? true : false
      );

      setIsprojectCost(
        ProjectData?.data?.costingReportStatus === 'COMPLETED' ? true : false
      );

      setOpenCostingReport(
        ProjectData?.data?.costingReportStatus === 'COMPLETED' ? true : false
      );
    }
  }, [ProjectData]);

  const handleCostingReport = () => {
    setOpenCostingReport(!openCostingReport);
  };

  const [loadingToapi, setLoadingToapi] = useState(false);
  const projectQuantity = [
    {
      title: `Quantity Report`,
      description: '',
      columns: ['Description', 'Unit', 'Quantity'],
      buttons: [
        {
          iconSrc: Icons.PDFIcon,
          downloadIconSrc: Icons.DwonloadIcon,
          altText: 'PDF Icon',
          isDisabled: true,
        },
        {
          iconSrc: Icons.ExcelIcon,
          downloadIconSrc: Icons.DwonloadIcon,
          altText: 'Excel Icon',
          isDisabled: true,
        },
      ],
    },
  ];
  const projectMaterial = [
    {
      title: `Material Report`,
      description: '',
      columns: ['Description', 'Unit', 'Quantity'],
      buttons: [
        {
          iconSrc: Icons.PDFIcon,
          downloadIconSrc: Icons.DwonloadIcon,
          altText: 'PDF Icon',
          isDisabled: true,
        },
        {
          iconSrc: Icons.ExcelIcon,
          downloadIconSrc: Icons.DwonloadIcon,
          altText: 'Excel Icon',
          isDisabled: true,
        },
      ],
    },
  ];
  const projectCost = [
    {
      title: `Costing Report`,
      description: '',
      columns: [
        'Description',
        'Unit',
        'Quantity',
        'Rate in PKR',
        'Amount in PKR',
        'Mohandes Rates',
        'Total Mohandes',
      ],
      buttons: [
        {
          iconSrc: Icons.PDFIcon,
          downloadIconSrc: Icons.DwonloadIcon,
          altText: 'PDF Icon',
          isDisabled: costingStatusReport === 'COMPLETED' ? true : false,
        },
        {
          iconSrc: Icons.ExcelIcon,
          downloadIconSrc: Icons.DwonloadIcon,
          altText: 'Excel Icon',
          isDisabled: costingStatusReport === 'COMPLETED' ? true : false,
        },
      ],
    },
  ];

  const createProjectMutation = NextProject(
    setLoadingToapi,
    setMaterialStatusReport,
    setCostingStatusReport,
    navigate,
    projectID
  );
  const CreateMaterialReportMutation = useCreateMaterialReportMutation(
    setLoadingToapi,
    setMaterialStatusReport,
    setCostingStatusReport,
    navigate
  );
  const createMaterialReport = () => {
    setLoadingToapi(true);
    CreateMaterialReportMutation.mutate(projectID);
  };
  // const createCostingReport = () => {
  //   setLoadingToapi(true);
  //   const projectData = {
  //     type: 'costing',
  //   };
  //   createProjectMutation.mutate(projectData);
  // };
  return {
    isLoading,
    quantityReport,
    materialReport,
    costingReport,
    materialStatusReport,
    costingStatusReport,
    isprojectMaterial,
    // isprojectCost,
    loadingToapi,
    projectQuantity,
    projectMaterial,
    projectCost,
    createMaterialReport,
    // createCostingReport,
    handleCostingReport,
    openCostingReport,
    ProjectData,
    navigate,
    TextWeight,
    projectID,
    setCostingReport,
    setCostingStatusReport,
  };
};
